import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {required} from '@vuelidate/validators';

import QmSystem from './QmSystem';

export default class QmSubject extends BaseModel {
  constructor({
    id,
    designation = undefined,
    system = undefined,
    description = undefined,
  }) {
    super(id, '', designation);
    this.designation = designation;
    this.description = description;
    this.system = system ? new QmSystem(system) : undefined;
  }

  static get fkName() {
    return 'qm_system_id';
  }

  get fkName() {
    return QmSubject.fkName;
  }

  static get apiRoute() {
    return 'qm_subject';
  }

  get listPageRoute() {
    return QmSubject.listPageRoute;
  }

  static get listPageRoute() {
    return 'qmSubjectList';
  }

  static get defaultSort() {
    return {
      property: 'designation',
      order: 'asc',
    };
  }

  get defaultSort() {
    return QmSubject.defaultSort;
  }

  getDefaultSort() {
    return QmSubject.defaultSort;
  }

  get apiRoute() {
    return QmSubject.apiRoute;
  }

  get config() {
    return QmSubject.config;
  }

  static get detailPageRoute() {
    return 'qmSubjectDetail';
  }

  get detailPageRoute() {
    return QmSubject.detailPageRoute;
  }

  static get config() {
    return {
      addable: false,
      duplicatable: false,
      importable: false,
      browsable: false,
      deletable: false,
    };
  }

  static get joinAttrsKey() {
    return ['system', 'designation'];
  }

  static get listDisplayAttrs() {
    return this.getAttributes(
      ['designation', 'systemNumber', 'creationDate', 'modificationDate'],
      ['system'],
    );
  }

  static get detailAttrs() {
    return this.getAttributes(['system', 'designation']);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['system', 'designation']);
  }

  static get allAttributes() {
    return [
      new AT.StringAttribute({
        name: 'designation',
        validations: {required},
        tableProperties: {
          header: 'hit-app.quality-management.subject-designation',
          maxWidth: '2fr',
        },
      }),
      this.DESCRIPTION_RICH_TEXT_ATTRIBUTE(),
      new AT.FkQmSystemAttribute({
        name: 'system',
        joinPath: ['qm_system!fk_qm_subject_qm_system_id_qm_system'],
        fkToUpdate: 'qm_system_id',
        tableProperties: {
          header: 'hit-app.quality-management.system-short',
        },
      }),
      // Display-only: number lives on qm_system, not qm_subject
      new AT.NotFetchedAttribute({
        name: 'systemNumber',
        readOnly: true,
        tableProperties: {
          header: 'hit-app.quality-management.system-short',
          maxWidth: '0.5fr',
        },
        transform: (item) => item?.system?.number ?? '',
      }),
      new AT.ArrayAttribute({
        name: 'roles',
        column: 'qualification!qm_subject_role(id)',
        transform: (objArray) => objArray.map((x) => x.id),
        tableProperties: {
          header: 'hit-base.common.role',
        },
      }),
      new AT.DateAttribute({
        name: 'creationDate',
        column: 'creation_date',
        tableProperties: {
          header: 'hit-base.common.creation-date',
          hideByDefault: true,
        },
      }),
      new AT.DateAttribute({
        name: 'modificationDate',
        column: 'modification_date',
        tableProperties: {
          header: 'hit-base.common.last-modified',
          hideByDefault: true,
        },
      }),
    ];
  }
}
